var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showList)?[_c('marshal-booking-list')]:(_vm.isMarshal)?[_c('marshal-booking-view')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }